export default __webpack_public_path__ + "static/media/link.3ebc2e0b.svg";